export const VOUCHER_STATUS = {
  notSet: '',
  valid: 'Active',
  invalid: 'Invalid',
  expired: 'Expired',
} as const;

export type VoucherStatus = typeof VOUCHER_STATUS[keyof typeof VOUCHER_STATUS];
